import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';

declare global {
  // eslint-disable-next-line no-var
  var grecaptcha: any;
}

@Injectable({
  providedIn: 'root',
})
export class CaptchaRepositoryAdapter {
  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
  ) { }

  private loadScript(): Promise<void> {
    return new Promise((resolve) => {
      if (globalThis.grecaptcha) return resolve();
      const script = this.document.createElement('script');
      script.src = `${environment.RECAPTCHA_V3_API_URL}?render=${environment.RECAPTCHA_V3_SITE_KEY}`;
      script.async = true; script.defer = true;
      script.onload = () => resolve();
      this.document.head.appendChild(script);
    });
  }

  async execute(action: string = 'submit'): Promise<string> {
    await this.loadScript();
    return new Promise((resolve, reject) => {
      globalThis.grecaptcha.ready(async () => {
        try {
          const token = await globalThis.grecaptcha.execute(environment.RECAPTCHA_V3_SITE_KEY, { action });
          resolve(token);
        } catch (err) {
          reject(err);
        }
      });
    });
  }

  destroy(): void {
    // Eliminar scripts de reCAPTCHA
    const scripts = this.document.querySelectorAll(`script[src*="recaptcha"], script[src*="gstatic.com/recaptcha"]`);
    scripts.forEach((script) => script.remove());

    // Eliminar badges de reCAPTCHA
    const badges = this.document.querySelectorAll('.grecaptcha-badge');
    badges.forEach((badge) => {
      const parent = badge.parentElement;
      if (parent) {
        parent.remove();
      } else {
        badge.remove();
      }
    });

    // Eliminar iframes de reCAPTCHA
    const iframes = this.document.querySelectorAll('iframe[src*="recaptcha"], iframe[title*="recaptcha"]');
    iframes.forEach((iframe) => iframe.remove());

    // Eliminar contenedores de reCAPTCHA (divs con estilos inline que Google inyecta)
    const recaptchaContainers = this.document.querySelectorAll('div[style*="visibility: hidden"]');
    recaptchaContainers.forEach((container) => {
      if (container.querySelector('iframe[src*="recaptcha"]') || container.querySelector('.grecaptcha-badge')) {
        container.remove();
      }
    });

    // Limpiar objeto global
    if (globalThis.grecaptcha) {
      delete (globalThis as any).grecaptcha;
    }

    // Limpiar callbacks de Google
    if ((globalThis as any).___grecaptcha_cfg) {
      delete (globalThis as any).___grecaptcha_cfg;
    }
  }

}
